/* eslint-disable import/no-anonymous-default-export */
import { message } from "antd";
import axios from "axios";
import API_MAP from "../../services/uri";
import errorHandler from "./errorHandler";

export const createWeddingGift = async (credential) => {
	try {
		const response = await axios.post(`${API_MAP.addGift}`, credential);
		const { hasError } = response.data;
		if (hasError) {
			message.error(response.data.errors.message);
			console.log("Create wedding gift data res =====> \n", response);
		} else {
			return response;
		}
	} catch (error) {
		return errorHandler(error);
	}
};

export const fetchAllGifts = async ({ weddingId }) => {
	try {
		const response = await axios.get(
			`${API_MAP.fetchAllGift}?weddingId=${weddingId || ""}`
		);
		const { hasError } = response.data;
		if (hasError) {
			message.error(response.data.errors.message);
			console.log("Get gift data res =====> \n", response);
		} else {
			return response.data;
		}
	} catch (error) {
		return errorHandler(error);
	}
};

export const deleteGift = async (credentials) => {
	const response = await axios.delete(
		`${API_MAP.deleteGift}?giftId=${credentials}`
	);
	return response;
};

export const deleteGiftimg = async (credentials) => {
	const { giftID, imageID } = credentials;
	const response = await axios.delete(
		`${API_MAP.deleteGiftImg}?giftId=${giftID}&imageId=${imageID}`
	);
	return response;
};

export const editGiftItem = async (credentials) => {
	const response = await axios.put(`${API_MAP.editGift}`, credentials);
	return response;
};

export const fetchDonations = async () => {
	try {
		const response = await axios.get(`${API_MAP.fetchDonations}`);
		const { hasError } = response.data;
		if (hasError) {
			message.error(response.data.errors.message);
			console.log("Donations data res =====> \n", response);
		} else {
			return response.data.data;
		}
	} catch (error) {
		return errorHandler(error);
	}
};

export const donationToWedding = async (credentials) => {
	const response = await axios.post(`${API_MAP.donate}`, credentials);
	return response;
};

async function thankADonor(data) {
	try {
		const response = await axios.post(`${API_MAP.thankDonor}`, data);
		const { hasError } = response.data;
		if (hasError) {
			// message.error(response.data.errors.message);
			console.log("Thank Donor error data res =====> \n", response);
		} else {
			return response.data.data;
		}
	} catch (error) {
		return errorHandler(error);
	}
}

// export const addPlan = async (credentials) => {
// 	try {
// 		const response = await axios.post(`${API_MAP.addPlan}`, credentials);
// 		const { hasError } = response.data;
// 		if (hasError) {
// 			message.error(response.data.errors.message);
// 			console.log("Add plan tag data res =====> \n", response);
// 		} else {
// 			return response.data;
// 		}
// 	} catch (error) {
// 		return errorHandler(error);
// 	}
// };

// export const editPlan = async (credentials) => {
// 	try {
// 		const response = await axios.put(`${API_MAP.editPlan}`, credentials);
// 		const { hasError } = response.data;
// 		if (hasError) {
// 			message.error(response.data.errors.message);
// 			console.log("Edit plan data res =====> \n", response);
// 		} else {
// 			return response.data;
// 		}
// 	} catch (error) {
// 		return errorHandler(error);
// 	}
// };

// export const fetchPlans = async ({ filter, tag }) => {
// 	try {
// 		const response = await axios.get(
// 			`${API_MAP.viewPlans}?filter=${filter || "all"}&tag=${tag}`
// 		);
// 		const { hasError } = response.data;
// 		if (hasError) {
// 			message.error(response.data.errors.message);
// 			console.log("Get plan data res =====> \n", response);
// 		} else {
// 			return response.data;
// 		}
// 	} catch (error) {
// 		return errorHandler(error);
// 	}
// };

export default {
	thankADonor,
};
